export enum ValuationType {
    Sell = 'Sell',
    Rent = 'Rent',
}
